import "select2";

$(document).ready(function() {
	let platform = '';
	$(document).on('click', '.js-modal-button', function() {
		$('body').addClass('is-modal-open');
		$('.b-header').addClass('modal');
		let modal = $('.b-modal[data-modal=' + $(this).attr('data-modal') + ']');
		modal.find('.js-store-list').hide().html('');
		modal.find('.js-store-select').val('');
		modal.show();
		platform = $(this).data('platform');
	});

	$('.js-store-select').select2({
		dropdownParent: $('.js-store-select').parent(),
		minimumResultsForSearch: -1,
		placeholder: "Choose Your Region",
		allowClear: false,
	});

	$(document).on('change', '.js-store-select', function() {
		let html = '';
		let region = $(this).find(":selected").data('region');
		console.log(stores[platform]);
		if (typeof stores[platform] != 'undefined') {
			for(let key in stores[platform][region]) {
				html += '<li class="b-modal__store-item">';
				html += '<a href="' + stores[platform][region][key]['link'] + '" target="_blank">' + stores[platform][region][key]['name'] + '</a>';
				html += '</li>';
			}
		}
		$('.js-store-list').show().html(html);
	});
});



// WEBPACK FOOTER //
// ./src/js/pages/main/store.js